export default __webpack_public_path__ + "static/media/SurfacePro.034c4463.svg";